<div class="genie-page">
  <!-- Page Header -->
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="builderService.navigateBack()">
        <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
      </div>
      <p class="genie-page-title">{{ 'Login' | translate }}</p>
      <p class="genie-page-subtitle">{{ 'Manage how users sign in to your store.' | translate }}</p>
    </div>
    <div class="header-right">
      <button class="cancel-btn" type="button" (click)="builderService.navigateBack()">
        {{ 'Cancel' | translate }}
      </button>
      <button class="submit-btn" type="button" (click)="saveToApplicationSettings()" [disabled]="productProgress">
        {{ 'Save Configuration' | translate }}
      </button>
    </div>
  </div>

  <!-- Auth0 Configuration Card -->
  <div class="section-card">
    <div class="card-header">
      <h3>{{ 'Auth0 Configuration' | translate }}</h3>
      <p class="card-subtitle">{{ 'Connect your Auth0 account to enable secure login.' | translate }}</p>
    </div>
    <div class="card-body">
      <div class="fields-grid-2">

        <!-- Auth0 Domain -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Auth0 Domain' | translate }}</label>
          </div>
          <div class="genie-input">
            <input type="text" [(ngModel)]="auth0_domain" placeholder="{{ 'Enter Auth0 Domain' | translate }}" />
          </div>
        </div>

        <!-- Auth0 Allowed Origins -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Auth0 Allowed Origins' | translate }}</label>
          </div>
          <div class="genie-input copy-field">
            <p id="textToCopy" class="copy-text">capacitor://localhost, https://localhost/, https:/*.auth.com/oauth/token</p>
            <span *ngIf="originsCopied" class="copied-label">{{ 'Copied!' | translate }}</span>
            <button class="copy-btn" type="button" (click)="copyToClipboard()">
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4.5" y="4.5" width="7.5" height="7.5" rx="1.5" stroke="currentColor" stroke-width="1"/>
                <path d="M4.5 8.5H3C2.44772 8.5 2 8.05228 2 7.5V2C2 1.44772 2.44772 1 3 1H8.5C9.05228 1 9.5 1.44772 9.5 2V4.5" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- Auth0 Client ID -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Auth0 Client ID' | translate }}</label>
          </div>
          <div class="genie-input">
            <input type="text" [(ngModel)]="auth0_clientId" placeholder="{{ 'Enter Auth0 Client ID' | translate }}" />
          </div>
        </div>

        <!-- Auth0 Redirect Url -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Auth0 Redirect Url' | translate }}</label>
          </div>
          <div class="genie-input">
            <input type="text" [(ngModel)]="auth0_redirect_uri" placeholder="{{ 'Enter Auth0 Redirect Url' | translate }}" />
          </div>
        </div>

      </div>

      <!-- Error Message -->
      <div *ngIf="error" class="error-message">
        <p>{{ error | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Login Options Card -->
  <div class="section-card">
    <div class="card-header">
      <h3>{{ 'Login Options' | translate }}</h3>
    </div>
    <div class="card-body options-body">

      <!-- Guest Checkout -->
      <div class="toggle-row">
        <div class="toggle-info">
          <p class="toggle-label">{{ 'Guest Checkout' | translate }}</p>
          <p class="toggle-desc">{{ 'Allow customers to place orders without creating an account.' | translate }}</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" [(ngModel)]="guestCheckOut" [checked]="guestCheckOut" />
          <span class="toggle-slider"></span>
        </label>
      </div>

      <!-- Phone Login -->
      <div class="toggle-row">
        <div class="toggle-info">
          <p class="toggle-label">{{ 'Phone Login' | translate }}</p>
          <p class="toggle-desc">{{ 'Allow customers to sign in using their phone number.' | translate }}</p>
          <div *ngIf="phoneLoginEnabled" @expandCollapse class="connection-field">
            <div class="genie-input">
              <input type="text" [(ngModel)]="auth0_connection" placeholder="{{ 'Auth0 Database Connection Name' | translate }}" />
            </div>
          </div>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" [(ngModel)]="phoneLoginEnabled" [checked]="phoneLoginEnabled" />
          <span class="toggle-slider"></span>
        </label>
      </div>

      <!-- Disable Social Login -->
      <div class="toggle-row">
        <div class="toggle-info">
          <p class="toggle-label">{{ 'Disable Social Login' | translate }}</p>
          <p class="toggle-desc">{{ 'Disable all social login providers from the sign in screen.' | translate }}</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" [(ngModel)]="disableSocialLogin" [checked]="disableSocialLogin" />
          <span class="toggle-slider"></span>
        </label>
      </div>

      <!-- Disable Signup -->
      <div class="toggle-row">
        <div class="toggle-info">
          <p class="toggle-label">{{ 'Disable Signup' | translate }}</p>
          <p class="toggle-desc">{{ 'Prevent new users from creating an account.' | translate }}</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" [(ngModel)]="disableSignup" [checked]="disableSignup" />
          <span class="toggle-slider"></span>
        </label>
      </div>

      <!-- Application Requires Approval -->
      <div class="toggle-row">
        <div class="toggle-info">
          <p class="toggle-label">{{ 'Application Requires Approval' | translate }}</p>
          <p class="toggle-desc">{{ 'Users must be approved by an admin before accessing the app.' | translate }}</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" [(ngModel)]="requiresApproval" [checked]="requiresApproval" />
          <span class="toggle-slider"></span>
        </label>
      </div>

      <!-- Lock Account to Device -->
      <div class="toggle-row no-border">
        <div class="toggle-info">
          <p class="toggle-label">{{ 'Lock Account to Device' | translate }}</p>
          <p class="toggle-desc">{{ 'Bind users account to a single device.' | translate }}</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" [(ngModel)]="deviceLock" [checked]="deviceLock" />
          <span class="toggle-slider"></span>
        </label>
      </div>

    </div>
  </div>

</div>
